/**
 * FW-142 — sessiz `'/'` varsayilani KALDIRILDI (olculdu: SPA hep kendi
 * originine istek atiyordu, gercek backend'e hicbir zaman ulasmiyordu —
 * bkz. FW-135 raporu, packages/shell/src/env.ts basligi). Adres artik
 * VITE_WEB_API_BASE_URL derleme-zamani ortam degiskeninden gelir ve
 * eksikse `requireBaseUrl` acilista YUKSEK SESLE durur.
 */
import '@fusapp-work/tokens/tokens.css'
import { createSurfaceApp, requireBaseUrl } from '@fusapp-work/shell'
import App from './App.vue'
import { routes } from './router/routes'
import { createOnboardingGuard } from './router/onboardingGuard'
import { requireAuthSurfaceUrl } from './config/authSurfaceUrl'
import en from './locales/en.json'
import tr from './locales/tr.json'

const loginUrl = requireAuthSurfaceUrl(import.meta.env.VITE_AUTH_SURFACE_URL)

const surfaceApp = createSurfaceApp({
  surface: 'app',
  rootComponent: App,
  routes,
  messages: { tr, en },
  apiClientOptions: {
    baseUrl: requireBaseUrl(import.meta.env.VITE_WEB_API_BASE_URL, 'VITE_WEB_API_BASE_URL'),
  },
})

// FW-200 — "kurulum bitmeden modül açılmaz" artık YOL SEVİYESİNDE de
// zorlanıyor (öncesinde yalnız OnboardingView'in kendi kabuğu vardı, bkz.
// router/onboardingGuard.ts başlığı). apps/console/src/main.ts'teki AYNI
// desen: `apiClient` `useApiClient()` injection'ı DEĞİL, createSurfaceApp()'in
// döndürdüğü GERÇEK istemci (bir router guard bileşen setup()'ı dışında çalışır).
//
// `loginUrl` — FW-205 (oturum yok, 401) dalı için giriş yüzeyi adresi;
// VITE_AUTH_SURFACE_URL ortam degiskeni main.ts acilirken dogrulanir.
surfaceApp.router.beforeEach(
  createOnboardingGuard(surfaceApp.apiClient, {
    loginUrl,
  }),
)

surfaceApp.mount('#app')
